module.exports = __webpack_public_path__ + "media/images/report_areas/gcna-264092fb7353e4701d163b5ba3f60e08.png";